import { isExpenseCategorySlug } from './expenseCategories';

export type ExpenseInputValidation = { ok: true } | { ok: false; message: string };

const ISO_DATE = /^\d{4}-\d{2}-\d{2}$/;

export function validateExpenseInput(params: {
  categorySlug: string;
  amount: number;
  description?: string | null;
  expenseDate?: string | null;
  dueDate?: string | null;
  paymentStatus?: string | null;
}): ExpenseInputValidation {
  if (!isExpenseCategorySlug(params.categorySlug)) {
    return { ok: false, message: 'Elegí una categoría válida.' };
  }
  if (!Number.isFinite(params.amount) || params.amount <= 0) {
    return { ok: false, message: 'El monto debe ser mayor a cero.' };
  }
  if (params.categorySlug === 'other') {
    const desc = (params.description ?? '').trim();
    if (!desc) {
      return { ok: false, message: 'Indicá una descripción para la categoría Otros.' };
    }
  }
  const expenseDate = (params.expenseDate ?? '').trim();
  if (expenseDate && !ISO_DATE.test(expenseDate)) {
    return { ok: false, message: 'La fecha del gasto no es válida.' };
  }
  const dueDate = (params.dueDate ?? '').trim();
  if (dueDate) {
    if (!ISO_DATE.test(dueDate)) {
      return { ok: false, message: 'La fecha de vencimiento no es válida.' };
    }
    if (expenseDate && dueDate < expenseDate) {
      return { ok: false, message: 'El vencimiento no puede ser anterior a la fecha del gasto.' };
    }
  }
  if (
    params.paymentStatus != null &&
    params.paymentStatus !== '' &&
    params.paymentStatus !== 'unpaid' &&
    params.paymentStatus !== 'paid' &&
    params.paymentStatus !== 'partial'
  ) {
    return { ok: false, message: 'El estado de pago no es válido.' };
  }
  return { ok: true };
}

/**
 * Fecha futura: se permite cargarla (factura con fecha del comprobante adelantada),
 * pero el preset por defecto de la lista termina en hoy — el gasto queda invisible
 * hasta cambiar el filtro. El formulario muestra un aviso no-bloqueante.
 */
export function isFutureExpenseDate(
  expenseDate: string | null | undefined,
  todayIso: string
): boolean {
  const d = (expenseDate ?? '').trim().slice(0, 10);
  const today = (todayIso ?? '').trim().slice(0, 10);
  if (!ISO_DATE.test(d) || !ISO_DATE.test(today)) return false;
  return d > today;
}

export function expenseVoidRejection(params: {
  activeSettlementCount: number;
  reason: string;
}): string | null {
  if (params.activeSettlementCount > 0) {
    return 'Anulá los pagos primero.';
  }
  if (params.reason.trim().length < 3) {
    return 'Indicá un motivo de al menos 3 caracteres.';
  }
  return null;
}
